import ActiveController from "rapid/controller";

export class photoInputController extends ActiveController {
    constructor($injector, $rootScope) {
        "ngInject";
        super($injector);

        this.$rootScope = $rootScope;
        this.componentId = angular.copy(Math.random().toString(36).substr(2, 10));
    }

    changeSize(value) {
        if (!this.ratio && !this.customRatio) {
            return;
        }

        let wIndex, hIndex;

        switch (this.ratio) {
            case "square":
                wIndex = 1;
                hIndex = 1;
                break;
            case "landscape":
                wIndex = 3;
                hIndex = 2;
                break;
            case "portrait":
                wIndex = 2;
                hIndex = 3;
                break;
            case "custom":
                wIndex = this.customRatio.width ? this.customRatio.width : this.layoutWidth;
                hIndex = this.customRatio.height ? this.customRatio.height : this.layoutHeight;
                break;
            default:
                wIndex = 1;
                hIndex = 1;
                break;
        }

        if (value === "height") {
            this.model.width = Math.round((this.model.height * wIndex) / hIndex);
        } else {
            this.model.height = Math.round((this.model.width * hIndex) / wIndex);
        }

    }
}



// WEBPACK FOOTER //
// ./sources/components/common/photo-input/photo-input.controller.js